import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCarrierListOutput } from './GetCarrierListOutput';

export class GetCarrierListService extends HttpServiceBase {

  handle = (): Promise<Result<GetCarrierListOutput> | null> => {
    const promise = this.http.get<Result<GetCarrierListOutput>>(`${this.baseUrlSislogApi}/v2/carrier`);
    return promise;
  }
}